// Mock data for courses and categories
export const MOCK_CATEGORIES = [
    { id: 1, name: 'Web Development', description: 'Build modern websites and applications' },
    { id: 2, name: 'Data Science', description: 'Analyze data and build ML models' },
    { id: 3, name: 'Digital Marketing', description: 'Master online marketing strategies' },
    { id: 4, name: 'Design', description: 'Create stunning visual experiences' },
    { id: 5, name: 'Business', description: 'Grow your business skills' },
    { id: 6, name: 'Photography', description: 'Capture professional photos' },
    { id: 7, name: 'Music', description: 'Learn instruments and theory' },
    { id: 8, name: 'Fitness', description: 'Stay healthy and active' }
];

export const MOCK_COURSES = [
    {
        id: 1,
        title: 'Complete Web Development Bootcamp',
        description: 'Master HTML, CSS, JavaScript, React, Node.js and become a full-stack developer',
        thumbnail: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800',
        price: 49.99,
        rating: 4.8,
        students_count: 12543,
        level: 'Beginner',
        category_id: 1,
        lessons: [
            { id: 1, title: 'Introduction to HTML', duration: '15:00' },
            { id: 2, title: 'CSS Fundamentals', duration: '22:00' },
            { id: 3, title: 'JavaScript Basics', duration: '35:00' },
            { id: 4, title: 'React Essentials', duration: '40:00' },
            { id: 5, title: 'Building Projects', duration: '60:00' }
        ]
    },
    {
        id: 2,
        title: 'Python for Data Science',
        description: 'Learn Python, NumPy, Pandas, and machine learning fundamentals',
        thumbnail: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=800',
        price: 59.99,
        rating: 4.9,
        students_count: 8932,
        level: 'Intermediate',
        category_id: 2,
        lessons: [
            { id: 1, title: 'Python Basics', duration: '25:00' },
            { id: 2, title: 'NumPy and Pandas', duration: '30:00' },
            { id: 3, title: 'Data Visualization', duration: '28:00' },
            { id: 4, title: 'Machine Learning', duration: '45:00' }
        ]
    },
    {
        id: 3,
        title: 'Digital Marketing Masterclass',
        description: 'Complete guide to SEO, social media, email marketing and analytics',
        thumbnail: 'https://images.unsplash.com/photo-1432888622747-4eb9a8f2c293?w=800',
        price: 39.99,
        rating: 4.7,
        students_count: 15621,
        level: 'Beginner',
        category_id: 3,
        lessons: [
            { id: 1, title: 'SEO Fundamentals', duration: '20:00' },
            { id: 2, title: 'Social Media Marketing', duration: '25:00' },
            { id: 3, title: 'Email Marketing', duration: '18:00' },
            { id: 4, title: 'Analytics & Tracking', duration: '22:00' }
        ]
    },
    {
        id: 4,
        title: 'UI/UX Design Fundamentals',
        description: 'Learn design thinking, prototyping, and create beautiful user interfaces',
        thumbnail: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800',
        price: 44.99,
        rating: 4.6,
        students_count: 7234,
        level: 'Beginner',
        category_id: 4,
        lessons: [
            { id: 1, title: 'Design Thinking', duration: '30:00' },
            { id: 2, title: 'Wireframing', duration: '25:00' },
            { id: 3, title: 'Prototyping in Figma', duration: '35:00' }
        ]
    },
    {
        id: 5,
        title: 'Financial Planning for Beginners',
        description: 'Master personal finance, investing, and wealth building strategies',
        thumbnail: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800',
        price: 34.99,
        rating: 4.5,
        students_count: 5432,
        level: 'Beginner',
        category_id: 5,
        lessons: [
            { id: 1, title: 'Budgeting Basics', duration: '20:00' },
            { id: 2, title: 'Investment Fundamentals', duration: '30:00' },
            { id: 3, title: 'Retirement Planning', duration: '25:00' }
        ]
    },
    {
        id: 6,
        title: 'Professional Photography',
        description: 'Learn camera settings, composition, lighting and post-processing',
        thumbnail: 'https://images.unsplash.com/photo-1516035069371-29a1b244cc32?w=800',
        price: 54.99,
        rating: 4.8,
        students_count: 6789,
        level: 'Intermediate',
        category_id: 6,
        lessons: [
            { id: 1, title: 'Camera Basics', duration: '22:00' },
            { id: 2, title: 'Composition Techniques', duration: '28:00' },
            { id: 3, title: 'Lighting Mastery', duration: '35:00' },
            { id: 4, title: 'Photo Editing', duration: '40:00' }
        ]
    },
    {
        id: 7,
        title: 'Guitar Masterclass',
        description: 'From beginner to advanced - learn chords, scales, and songs',
        thumbnail: 'https://images.unsplash.com/photo-1510915361894-db8b60106cb1?w=800',
        price: 42.99,
        rating: 4.7,
        students_count: 4521,
        level: 'Beginner',
        category_id: 7,
        lessons: [
            { id: 1, title: 'Basic Chords', duration: '18:00' },
            { id: 2, title: 'Strumming Patterns', duration: '20:00' },
            { id: 3, title: 'Playing Songs', duration: '30:00' }
        ]
    },
    {
        id: 8,
        title: 'Complete Fitness Program',
        description: 'Build muscle, lose fat, and improve overall health and wellness',
        thumbnail: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=800',
        price: 29.99,
        rating: 4.6,
        students_count: 9876,
        level: 'Beginner',
        category_id: 8,
        lessons: [
            { id: 1, title: 'Workout Fundamentals', duration: '25:00' },
            { id: 2, title: 'Nutrition Basics', duration: '30:00' },
            { id: 3, title: 'Training Programs', duration: '35:00' }
        ]
    }
];
